import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss'],
})
export class LegendComponent {
  /** Une entrée affiche un rond de couleur (`color`) ou, si fournie, une icône Material (`icon` + `iconColor`). */
  @Input() legendItems: { description: string; color?: string; icon?: string; iconColor?: string }[] = [];
}
